<template>
  <div class="app-container">
    <el-tabs v-model="status" @tab-click="handleClick">
      <el-tab-pane label="全部" name="0"></el-tab-pane>
      <el-tab-pane label="待分配" name="1"></el-tab-pane>
      <el-tab-pane label="已接单" name="2"></el-tab-pane>
      <el-tab-pane label="处理中" name="3"></el-tab-pane>
      <el-tab-pane label="已完成" name="4"></el-tab-pane>
      <el-tab-pane label="已评论" name="5"></el-tab-pane>
    </el-tabs>
    <div class="screen">
      <el-form
        label-width="200px"
        :inline="true"
        :model="screen"
        class="form-inline"
        label-position="left"
      >
        <!-- <el-form-item label="选择园区">
          <el-select
            filterable
            v-model="screen.park_id"
            placeholder="请选择园区"
            :disabled="userInfo.park_id != 0"
            @change="screenParkchange"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="报事企业">
          <el-select
            filterable
            v-model="screen.company_id"
            @change="screenCompanychange"
            placeholder="请选择报事企业"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in companyList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="处理人">
          <el-input v-model="screen.user" placeholder="请输入处理人"></el-input>
        </el-form-item>
        <el-form-item label="工单编号">
          <el-input v-model="screen.user" placeholder="请输入工单编号"></el-input>
        </el-form-item>
        <el-form-item label="工单ID">
          <el-input v-model="screen.user" placeholder="请输入工单ID"></el-input>
        </el-form-item> -->

        <el-form-item label="报事人">
          <el-select
            filterable
            v-model="screen.user_id"
            placeholder="请选择报事人"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in userList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报事报修类型">
          <el-select
            filterable
            v-model="screen.type"
            placeholder="请选择报事报修类型"
          >
            <el-option
              :label="item.name"
              :value="item.value"
              v-for="(item, index) in typeList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>


        
        <div v-show="fold">
          <el-form-item label="分配人">
          <el-select
            filterable
            v-model="screen.allot_user_id"
            placeholder="请选择分配人"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in userList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
          <el-form-item label="处理人">
            <el-select
              filterable
              v-model="screen.dispose_user_id"
              placeholder="请选择处理人"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="(item, index) in userList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工单状态">
            <el-select
              filterable
              :disabled="status != 0"
              v-model="screen.status"
              placeholder="请选择工单状态"
            >
              <el-option
                :label="item.name"
                :value="item.value"
                v-for="(item, index) in statusList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工单原因类型">
            <el-select
              filterable
              v-model="screen.maintenance_type_id"
              placeholder="请选择工单原因类型的大类"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                :label="item.title"
                :value="item.id"
                v-for="(item, index) in maintenanceList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="报事角色">
            <el-select
              filterable
              v-model="screen.role_id"
              placeholder="请选择报事角色"
            >
            <el-option label="全部" value=""></el-option>
            <el-option
              :label="item.title"
              :value="item.id"
              v-for="(item, index) in roleList"
              :key="index"
            ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="完成的开始时间">
            <el-date-picker
              v-model="screen.finish_time_start"
              type="date"
              placeholder="完成的开始时间"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="完成的结束时间">
            <el-date-picker
              v-model="screen.finish_time_end"
              type="date"
              placeholder="完成的结束时间"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="创建的开始时间">
            <el-date-picker
              v-model="screen.create_time_start"
              type="date"
              placeholder="创建的开始时间"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="创建的结束时间">
            <el-date-picker
              v-model="screen.create_time_end"
              type="date"
              placeholder="创建的结束时间"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="搜索" class="searchs"  style="width: 250px;">
            <el-button
              size="medium"
              type="primary"
              @click="(page = 1), fetchData()"
              >查询</el-button
            >
            <el-button size="medium" type="primary" plain @click="chongZhi()"
              >重置</el-button
            >
            <el-button
        type="warning"
        @click="derive()"
        style="margin-bottom: 5px"
        v-if="roles.includes('/maintenance/export')"
        >导出</el-button
      >
          </el-form-item>
        </div>

        <el-form-item v-show="!fold" label="搜索" class="searchs"  style="width: 250px;">
          <el-button
            size="medium"
            type="primary"
            @click="(page = 1), fetchData()"
            >查询</el-button
          >
          <el-button size="medium" type="primary" plain @click="chongZhi()"
            >重置</el-button
          > 
          <el-button
        type="warning"
        @click="derive()"
        style="margin-bottom: 5px"
        v-if="roles.includes('/maintenance/export')"
        >导出</el-button
      >
        </el-form-item>
      </el-form>
      <div class="fold" v-show="fold" @click="fold = !fold">
        折叠 <i class="el-icon-arrow-up"></i>
      </div>
      <div class="fold" v-show="!fold" @click="fold = !fold">
        展开 <i class="el-icon-arrow-down"></i>
      </div>
    </div>

    <el-table
      max-height="800"  v-loading="listLoading" 
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (page - 1) * page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column label="工单编号" min-width="180">
        <template slot-scope="scope">
          {{ scope.row.maintenance_no }}
        </template>
      </el-table-column>
      <el-table-column label="园区" align="center" width="200">
        <template slot-scope="scope">
          <span>
            {{ scope.row.park ? scope.row.park.name : "" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="公司" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.company">
            {{ scope.row.company ? scope.row.company.name : "" }}
          </span>
          <span v-if="scope.row.residence_house">
            {{ scope.row.residence_house ? scope.row.residence_house.name : "" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="报事类型" align="center">
        <template slot-scope="scope">
          {{
            scope.row.type == 1
              ? "自查报事"
              : scope.row.type == 2
              ? "业主报事"
              : scope.row.type == 3
              ? "硬件报修" : scope.row.type == 4
              ? "巡检报修"
              : scope.row.type == 5
              ? "住宅报修"
              : "---"
          }}
        </template>
      </el-table-column>
      <el-table-column label="紧急程度" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.level == 1" type="">普通</el-tag>
          <el-tag v-if="scope.row.level == 2" type="warning">严重</el-tag>
          <el-tag v-if="scope.row.level == 3" type="danger">紧急</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="报事地点" align="center" width="200">
        <template slot-scope="scope">
          {{ scope.row.address }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" align="center" min-width="180">
        <template slot-scope="scope">
          {{ scope.row.create_time }}
        </template>
      </el-table-column>
      <el-table-column label="原因大类" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.maintenance_type">{{
            scope.row.maintenance_type.title
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="报事描述" align="center">
        <template slot-scope="scope">
          <span
            style="
              white-space: nowrap;

              overflow: hidden;

              text-overflow: ellipsis;
            "
          >
            {{ scope.row.des }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="报事图片" align="center">
        <template slot-scope="scope">
          <img
            v-if="scope.row.image"
            class="tableIcon"
            alt=""
            srcset=""
            :src="scope.row.is_cy == 1 ? imageUrl + scope.row.image.split(',')[0] :  imageOss + scope.row.image.split(',')[0]"
          />
        </template>
      </el-table-column>
      <el-table-column label="报事人" align="center" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.user">{{ scope.row.user.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="响应/处理超时" align="center" width="200">
        <template slot-scope="scope">
          <span v-if="scope.row.overdue_time">
            {{ scope.row.overdue_time }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="分派人" align="center">
        <template slot-scope="scope">
          {{ scope.row.allotUser ? scope.row.allotUser.name : "" }}
        </template>
      </el-table-column>
      <el-table-column label="工单状态" min-width="110" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 1">待分配</span>
          <span v-if="scope.row.status == 2">已接单</span>
          <span v-if="scope.row.status == 3">处理中</span>
          <span v-if="scope.row.status == 4">已完成</span>
          <span v-if="scope.row.status == 5">已评价</span>
          <span v-if="scope.row.status == 6">已关闭</span>
          <!-- <el-tag
            :type="scope.row.status == '1' ? 'success' : 'danger'"
            disable-transitions>{{scope.row.status == 1 ? '启用' : '禁用'}}</el-tag> -->
        </template>
      </el-table-column>
      <el-table-column label="处理人" align="center">
        <template slot-scope="scope">
          {{ scope.row.dispose_user ? scope.row.dispose_user.name : "" }}
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="操作" width="330" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            @click="getLog(scope.row.id)"
            v-if="roles.includes('/maintenance/maintenance_log_lists')"
            >跟踪订单</el-button
          >
          <el-button
            size="mini"
            type="warning"
            @click="transferOrder(scope.row)"
            v-if="
              roles.includes('/maintenance/transfer') &&
              scope.row.status != 5 &&
              scope.row.status != 4 &&
              scope.row.status != 6
            "
            >转单</el-button
          >
          <el-button
            size="mini"
            type="info"
            @click="sendOrders(scope.row)"
            v-if="
              roles.includes('/maintenance/dispatch') && scope.row.status == 1
            "
            >派单</el-button
          >
          <el-button
            size="mini"
            type="primary"
            @click="comment(scope.row)"
            v-if="
              roles.includes('/maintenance/comment') && scope.row.status == 4
            "
            >批注</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="closeGd(scope.row)"
            v-if="roles.includes('/maintenance/close') && scope.row.status != 6"
            >关闭工单</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[15, 30, 50]"
      :page-size="page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="700px"
      title="转单"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleCloses"
    >
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        label-position="right"
        label-width="150px"
        class="formBox"
        :rules="rules"
      >
        <el-form-item label="转单原因" prop="maintenance_transfer_reason_id">
          <el-select
            filterable
            v-model="ruleForm.maintenance_transfer_reason_id"
            placeholder="请选择转单原因"
          >
            <el-option
              :label="item.title"
              :value="item.id"
              v-for="(item, index) in reasonList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="工单原因类型的大类" prop="to_maintenance_type_id">
          <el-select
            filterable
            @change="changeType"
            v-model="ruleForm.to_maintenance_type_id"
            placeholder="请选择工单原因类型的大类"
          >
            <el-option
              :label="item.title"
              :value="item.id"
              v-for="(item, index) in maintenanceLists1"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="工单原因类型的小类"
          prop="to_maintenance_type_son_id"
          v-if="maintenanceTwoList.length"
        >
          <el-select
            filterable
            :disabled="ruleForm.to_maintenance_type_id == ''"
            v-model="ruleForm.to_maintenance_type_son_id"
            placeholder="请选择工单原因类型的小类"
            @change="reasonChildrenChange"
            clearable
          >
            <el-option
              :label="item.title"
              :value="item.id"
              v-for="(item, index) in maintenanceTwoList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="接收人" prop="to_user_id">
          <el-select
            filterable
            v-model="ruleForm.to_user_id"
            placeholder="请选择处理人"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in ByUserList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="des">
          <el-input
            type="textarea"
            v-model="ruleForm.des"
            placeholder="请输入描述"
          ></el-input>
        </el-form-item>
        <el-form-item label="图片" prop="image">
          <el-upload
            ref="upload"
            name="file[]"
            accept=".jpg,.png,.jpeg"
            :data="{ type: 'image' }"
            :class="{ disabled: uploadDisabled }"
            :headers="{ token: token }"
            :action="ossUpload"
            :limit="6"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :before-upload="beforeAvatarUpload"
            :on-success="handleAvatarSuccess"
            :on-change="handleEditChange"
          >
            <i class="el-icon-plus"></i> </el-upload
          ><!-- 已修改 -->
          <el-dialog :append-to-body="true" :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确定</el-button
          >
          <el-button @click="drawer = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
    <el-drawer
      size="700px"
      title="派单"
      :visible.sync="pdDrawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        ref="pdForm"
        :model="pdForm"
        label-position="right"
        label-width="150px"
        class="formBox"
        :rules="pdRules"
      >
        <el-form-item label="工单原因类型的大类">
          <el-input
            style="width: 60%"
            v-model="pdForm.maintenance_type.title"
            :readonly="true"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="工单原因类型的小类"
          prop="maintenance_type_son_id"
          v-if="maintenanceTwoList.length"
        >
          <el-select
            filterable
            style="width: 60%"
            v-model="pdForm.maintenance_type_son_id"
            placeholder="请选择工单原因类型的小类"
            @change="reasonSmall"
          >
            <el-option
              :label="item.title"
              :value="item.id"
              v-for="(item, index) in maintenanceTwoList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="接收人" prop="to_user_id">
          <el-select
            filterable
            style="width: 60%"
            v-model="pdForm.to_user_id"
            placeholder="请选择接收人"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="item in ByUserList"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="setSend('pdForm')">确定</el-button>
          <el-button @click="pdDrawer = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
    <el-drawer
      title="跟踪信息"
      :visible.sync="logDrawer"
      size="700px"
      direction="rtl"
    >
      <el-timeline :reverse="false" class="card">
        <el-timeline-item
          v-for="(item, index) in logList"
          :key="index"
          :timestamp="item.create_time"
          type="success"
          placement="top"
        >
          <el-card>
            <h4>{{ item.title }}</h4>
            <p>{{ item.des }}</p>
            <div
              v-if="item.maintenance_apply_info && item.type == 1"
              class="des-box"
            >
              <p>{{ item.maintenance_apply_info.des }}</p>
              <p v-if="item.maintenance_apply_info.image">
                <el-image
                  v-for="(img, ind) in item.maintenance_apply_info.image.split(
                    ','
                  )"
                  :key="ind"
                  style="width: 100px; height: 100px"
                  :src="item.maintenance_apply_info.is_cy == 1 ? imageUrl + img : imageOss + img"
                  fit="contain"
                  :preview-src-list="
                    $pathDispose(item.maintenance_apply_info.image.split(','),item.maintenance_apply_info.is_cy)
                  "
                >
                </el-image>
              </p>
            </div>
            <div v-if="item.maintenance_reply_info" class="des-box">
              <p>{{ item.maintenance_reply_info.des }}</p>
              <p v-if="item.maintenance_reply_info.image">
                <el-image
                  v-for="(img, ind) in item.maintenance_reply_info.image.split(
                    ','
                  )"
                  :key="ind"
                  style="width: 100px; height: 100px"
                  :src="item.maintenance_reply_info.is_cy == 1 ? imageUrl + img : imageOss + img"
                  fit="contain"
                  :preview-src-list="
                    $pathDispose(item.maintenance_reply_info.image.split(','),item.maintenance_apply_info.is_cy)
                  "
                >
                </el-image>
              </p>
            </div>
            <div v-if="item.maintenance_transfer_info" class="des-box">
              <p
                class="reason"
                v-if="item.maintenance_transfer_info.maintenanceTransferReason"
              >
                {{
                  item.maintenance_transfer_info.maintenanceTransferReason.title
                }}
              </p>
              <p>{{ item.maintenance_transfer_info.des }}</p>
              <p v-if="item.maintenance_transfer_info.image">
                <el-image
                  v-for="(
                    img, ind
                  ) in item.maintenance_transfer_info.image.split(',')"
                  :key="ind"
                  style="width: 100px; height: 100px; margin: 0 5px 5px 0"
                  :src="item.maintenance_transfer_info.is_cy == 1 ? imageUrl + img : imageOss + img"
                  fit="contain"
                  :preview-src-list="
                    $pathDispose(
                      item.maintenance_transfer_info.image.split(','),item.maintenance_transfer_info.is_cy
                    )
                  "
                >
                </el-image>
              </p>
            </div>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </el-drawer>
    <el-dialog
      title="关闭工单"
      :visible.sync="closeVisible"
      width="400px"
      :before-close="handleClose"
    >
      <el-input
        type="textarea"
        placeholder="请输入关闭原因"
        v-model="closeForm.close_reason"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="QrCloseGd()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  delImage,
  applyLists,
  infoAgo,
  openPark,
  openRole,
  openCompany,
  maintenanceType,
  getByUser,
  transfer,
  dispatch,
  reasonLists,
  openAgoUser,
  maintenanceLogLists,
  closeMaintenance,
  commentMaintenance,
  maintenanceExport
} from "@/api/index";
import { getToken } from "@/utils/auth";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      fold: false,
      logDrawer: false,
      logList: [],
      token: getToken(),
      list: [],
      page: 1,
      page_size: 15,
      typeList:[
      {
          name: "全部",
          value: "",
        },
        {
          name: "自查报事",
          value: "1",
        },
        {
          name: "业主报事",
          value: "2",
        },
        {
          name: "硬件报修",
          value: "3",
        },
        {
          name: "巡检报修",
          value: "4",
        },
        {
          name: "住宅报修",
          value: "5",
        },
      ],
      statusList: [
        {
          name: "全部",
          value: "",
        },
        {
          name: "待分配",
          value: "1",
        },
        {
          name: "已接单",
          value: "2",
        },
        {
          name: "处理中",
          value: "3",
        },
        {
          name: "已完成",
          value: "4",
        },
        {
          name: "已评价",
          value: "5",
        },
      ],
      screen: {
        park_id: "",
        user_id: "",
        status: "",
        company_id: "",
        allot_user_id: "",
        dispose_user_id: "",
        source: "",
        finish_time_start: "",
        finish_time_end: "",
        create_time_start: "",
        create_time_end: "",
        maintenance_type_id: "",
        type:'',
        role_id:''
      },
      ossUpload: this.$store.state.ossUpload,
      total: 0,
      parkList: [],
      companyList: [],
      drawer: false,
      ruleForm: {
        maintenance_transfer_reason_id: "",
        to_maintenance_type_id: "",
        source: 2,
        des: "",
        to_user_id: "",
        image: [],
        to_maintenance_type_son_id: "",
      },
      rules: {
        maintenance_transfer_reason_id: [
          {
            required: true,
            message: "请选择工单原因类型的大类",
            trigger: "blur",
          },
        ],
        to_maintenance_type_id: [
          {
            required: true,
            message: "请选择工单原因类型的大类",
            trigger: "change",
          },
        ],
      },
      pdForm: {
        id: "",
        to_user_id: "",
        maintenance_type_son_id: "",
        source: 2,
        maintenance_type: "",
        park_id: "",
      },
      pdRules: {
        maintenance_type_son_id: [
          {
            required: true,
            message: "请选择工单原因类型的小类",
            trigger: "blur",
          },
        ],
        to_user_id: [
          {
            required: true,
            message: "请选择接单人",
            trigger: "change",
          },
        ],
      },
      fileList: [],
      file: [],
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      uploadDisabled: false,
      maintenanceList: [],
      // 转单和派单大类
      maintenanceLists1: [],
      maintenanceTwoList: [],
      pdDrawer: false,
      ByUserList: [],
      parkId: "",
      reasonList: [],
      userList: [],
      status: 0,
      closeForm: {},
      closeVisible: false,
      roleList:[]
    };
  },
  mounted() {
    // 每隔5分钟定时刷新
    this.timer = setInterval(() => {
      this.fetchData();
    }, 120000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
      this.getScreenUrse(this.userInfo.park_id, this.userInfo.company_id);
      this.getMaintenanceList(this.userInfo.park_id);
      this.getCompany(this.userInfo.park_id);
      this.getRole(this.userInfo.park_id)
    } else {
      this.getMaintenanceList();
      this.getCompany();
      this.getScreenUrse("", this.userInfo.company_id);
      this.screen.park_id = "";
    }
    if (this.userInfo.company_id !== 0) {
      this.screen.company_id = this.userInfo.company_id;
    } else {
      this.screen.company_id = "";
    }
    // this.getPark();
    this.fetchData();
  },
  methods: {
// 获取角色
  getRole() {
    openRole({role_type:2, is_page: 2, park_id: this.$store.state.mainParkId }).then((response) => {
        this.roleList = response.data.lists;
      });
    },

// 导出
derive() {
  const loading = this.$loading({
          lock: true,
          text: '数据量过大，正在导出中...',
          spinner: 'el-icon-loading'
        });
  maintenanceExport(this.screen).then((res) => {
    loading.close();
        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel;charset=utf-8",
        });
        let downloadElement = document.createElement("a");
        let href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = res.name;
        // downloadElement.target="_blank"
        downloadElement.setAttribute("target", "_blank");
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
      }).catch(error =>{
        console.log(error)
        loading.close();
      });
    },

    comment(val) {
      this.$prompt("请输入批注", "批注", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          if (!value) {
            this.$message({
              type: "warning",
              message: "批注不能为空！",
            });
            return;
          }
          let data = {
            id: val.id,
            comment: value,
            source: 2,
            park_id: val.park_id,
          };
          commentMaintenance(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: code.msg,
              });
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 关闭工单
    closeGd(val) {
      this.closeForm = {
        id: val.id,
        close_reason: "",
        source: 2,
        park_id: val.park_id,
      };
      this.closeVisible = true;
    },
    QrCloseGd() {
      if (this.closeForm.close_reason) {
        closeMaintenance(this.closeForm).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.fetchData();
            this.closeVisible = false;
          }
        });
      } else {
        this.$message({
          message: "关闭原因不能为空！",
          type: "warning",
        });
      }
    },
    screenParkchange(e) {
      this.screen.company_id = "";
      this.screen.user_id = "";
      this.screen.allot_user_id = "";
      this.screen.dispose_user_id = "";
      this.screen.role_id = ''
      this.getCompany(e);
      this.getScreenUrse(e);
      this.getMaintenanceList(e);
      this.getRole(e);
    },
    screenCompanychange(e) {
      this.screen.user_id = "";
      this.screen.allot_user_id = "";
      this.screen.dispose_user_id = "";
      this.getScreenUrse(this.screen.park_id, e);
    },
    chongZhi() {
      this.screen = {
        park_id: "",
        user_id: "",
        status: "",
        company_id: "",
        allot_user_id: "",
        dispose_user_id: "",
        source: "",
        finish_time_start: "",
        finish_time_end: "",
        create_time_start: "",
        create_time_end: "",
        maintenance_type_id: "",
        status: "",
        type:'',
        role_id:''
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
        this.getCompany(this.userInfo.park_id);
        this.getScreenUrse(this.userInfo.park_id, this.userInfo.company_id);
      } else {
        this.getCompany();
        this.getScreenUrse("", this.userInfo.company_id);
        this.screen.park_id = "";
      }
      if (this.userInfo.company_id !== 0) {
        this.screen.company_id = this.userInfo.company_id;
      } else {
        this.screen.company_id = "";
      }
      this.fetchData();
    },
    getLog(id) {
      maintenanceLogLists({ maintenance_apply_id: id }).then((res) => {
        this.logList = res.data.lists;
        this.logDrawer = true;
      });
    },
    handleClick(tab, event) {
      this.screen.status = tab.index == 0 ?'': tab.index;
      this.status = tab.index;
      this.fetchData();
    },
    // 获取筛选接收人列表
    getScreenUrse(parkId = "", company_id = "") {
      openAgoUser({ is_page: 2, park_id: parkId, company_id: company_id,is_youke:2 }).then(
        (res) => {
          this.userList = res.data.lists;
        }
      );
    },

    getReasonLists() {
      reasonLists({ park_id: this.$store.state.mainParkId, is_page: 2, status: 1 }).then((res) => {
        this.reasonList = res.data.lists;
      });
    },

    // 确定派单
    setSend(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var data = {
            id: this.pdForm.id,
            to_user_id: this.pdForm.to_user_id || "",
            maintenance_type_son_id: this.pdForm.maintenance_type_son_id || "",
            source: 2,
          };
          dispatch(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.fetchData();
              this.pdDrawer = false;
            }
          });
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 获取接收人列表
    getByMaintenanceTypeUrse(parkId, typeId) {
      getByUser({ park_id: parkId, type_id: typeId }).then((res) => {
        this.ByUserList = res.data.lists;
      });
    },
    // 派单原因细类回调
    reasonSmall(e) {
      this.pdForm.to_user_id = "";
      this.getByMaintenanceTypeUrse(this.pdForm.park_id, e);
    },
    // 派单
    sendOrders(val) {
      this.pdForm.park_id = val.park_id;
      this.pdForm.id = val.id;
      this.pdForm.maintenance_type = val.maintenance_type;
      this.pdForm.maintenance_type_son_id = "";
      this.pdForm.to_user_id = "";
      this.getMaintenanceTwoList(val.maintenance_type_id, val.park_id);
      this.getByMaintenanceTypeUrse(val.park_id, val.maintenance_type_id);
      this.pdDrawer = true;
      this.$nextTick(() => {
        this.$refs.pdForm.clearValidate();
      });
    },
    // 转单时候小类
    reasonChildrenChange(e) {
      this.ruleForm.to_user_id = "";
      if (e) {
        this.getByMaintenanceTypeUrse(this.parkId, e);
      } else {
        this.getByMaintenanceTypeUrse(
          this.parkId,
          this.ruleForm.to_maintenance_type_id
        );
      }
    },
    // 转单
    transferOrder(val) {
      this.parkId = val.park_id;
      this.ruleForm = {
        id: val.id,
        maintenance_transfer_reason_id: "",
        to_maintenance_type_id: "",
        source: 2,
        des: "",
        to_user_id: "",
        image: [],
        to_maintenance_type_son_id: "",
      };
      this.maintenanceTwoList = [];
      this.getReasonLists();
      this.getMaintenanceList(val.park_id, true);
      this.drawer = true;
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
        this.$refs.upload.clearFiles();
      });
    },
    // 选中原因大类
    changeType(e, c) {
      this.ruleForm.to_maintenance_type_son_id = "";
      this.ruleForm.to_user_id = "";
      this.getByMaintenanceTypeUrse(this.parkId, e);
      this.getMaintenanceTwoList(e, this.parkId);
    },
    // 获取报事报修原因类型小类列表数据
    getMaintenanceTwoList(id, park_id = "") {
      maintenanceType({
        park_id: park_id,
        pid: id,
        level: 2,
        is_page: 2,
        status: 1,
      }).then((res) => {
        this.maintenanceTwoList = res.data.lists;
      });
    },
    // 获取报事报修原因类型列表数据
    getMaintenanceList(park_id = "", maintenanceLists1) {
      maintenanceType({
        park_id: this.$store.state.mainParkId,
        level: 1,
        is_page: 2,
        status: 1,
      }).then((res) => {
        if (maintenanceLists1) {
          this.maintenanceLists1 = res.data.lists;
        } else {
          this.maintenanceList = res.data.lists;
        }
      });
    },
    handleAvatarSuccess(res, file) {
      if (res.code === 200) {
        this.ruleForm.image.push(res.data.url);
      }
      this.uploadDisabled = this.ruleForm.image >= 6;
    },
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
    // 删除
    handleRemove(file) {
      const index = this.ruleForm.image.indexOf(file.response.data.url);
      this.delImg(file.response.data.url);
      if (index > -1) {
        this.ruleForm.image.splice(index, 1);
      }
    },
    // 查看
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 删除线上图片
    delImg(path) {
      delImage({ file: path }).then((ress) => {});
    },
    // 最多上传6张图，超过时隐藏上传按钮
    handleEditChange(file, fileList) {
      this.uploadDisabled = this.ruleForm.image.length >= 6;
    },
    handleSizeChange(val) {
      this.page_size = val;
      this.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.fetchData();
    },
    getInfo(id, parkId) {
      var that = this;
      infoAgo({ id: id, park_id: parkId }).then((res) => {});
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.pdForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    handleCloses(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          done();
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
        })
        .catch(() => {});
    },
    // 获取企业
    getCompany(park_id = "") {
      openCompany({ is_page: 2, park_id: park_id }).then((response) => {
        this.companyList = response.data.lists;
      });
    },
    // 获取园区
    getPark() {
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.image = this.ruleForm.image.toString();
          transfer(this.ruleForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.fetchData();
              this.drawer = false;
            }
          });
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      this.screen.page = this.page;
      this.screen.page_size = this.page_size;
      applyLists(this.screen).then((response) => {
        this.list = response.data.list.data;
        this.total = response.data.list.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding: 0 20px;
  overflow: auto;
}
.table-box {
  margin-top: 20px;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.searchs {
  ::v-deep .el-form-item__label {
    opacity: 0 !important;
    display: block;
  }
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
::v-deep .screen {
  padding: 0 50px 10px;
  border-bottom: 1px solid #e4e7ed;
  .el-input {
    width: 200px;
  }
  .el-form--inline .el-form-item {
    width: 23%;
  }
}
.card {
  .des-box {
    p {
      padding: 0 10px;
      &.reason {
        color: #ff3300;
      }
    }
  }
}
::v-deep .el-message {
  width: 100px !important;
  height: 10px;
}
.fold {
  text-align: center;
  font-size: 14px;
  color: #606266;
}
</style>
